// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1310":"15185aeb","1704":"46cd9a05","1881":"bd28e7b2","2009":"81ac32a8","2177":"e1426648","6477":"f2fa762e","6615":"15185aeb","8328":"993b2712","9256":"12286ebd"}[chunkId] + ".chunk.css";
};